import requestServices from './request';

export const signalService = {
  getBotSignals: async (cateName?: string, roomName?: string) => {
    try {
      let url = '/signal-events/bot-signals';
      
      // Thêm query params nếu có
      const params = new URLSearchParams();
      if (cateName) params.append('cateName', cateName);
      if (roomName) params.append('roomName', roomName);
      
      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
      
      const response = await requestServices.userClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching bot signals:', error);
      return [];
    }
  }
};
